<template>
  <div class="inner-graph-content fs13" v-if="seizures">
    <div class="print-info-area mt20 mb20">
      <div class="p20">
        <div class="header heghtHeader">
          <div class="styleHeader">
            <div class="fLeft">{{ $t('doctor_in_charge_colon') }} {{$t('doctor_doctor', {doctor: doctorInfo.name})}}</div>
            <div class="fRight">{{ $t('output_date_and_time') }} {{ pdf.currentDateTime }} &emsp; {{ totalPage }}/{{ totalPage }}</div>
          </div>
          <div class="titleHeder">
            <h1>{{ $t('patient_information_and_seizure_status_graph') }}</h1>
          </div>
        </div>
        <div v-if="info" class="content">
          <div class="child-infor mb10">
            <h3 class="fs18 mb-3">{{ $t('patient_information') }}</h3>
            <table class="table-patient-info">
              <tr>
                <td style="min-width: 150px">{{ $t('name') }}</td>
                <td nowrap class="p-info-txt" style="min-width: 234px">{{ pdf.child_name }}</td>
                <td style="min-width: 250px">{{ $t('gender') }}</td>
                <td nowrap class="p-info-txt" style="min-width: 120px">{{ gender }}</td>
              </tr>
              <tr>
                <td style="min-width: 150px">{{ $t('age') }}</td>
                <td nowrap class="p-info-txt" style="min-width: 234px">{{ $tc('age_ages', age) }}</td>
                <td style="min-width: 250px">{{ $t('average_number_of_seizures_patient') }}</td>
                <td class="p-info-txt" style="min-width: 120px">{{ $tc('time_times', basic_info.average_seizure) }}</td>
              </tr>
            </table>
          </div>
          <div class="mb15">
            <h3 class="titleHeading">{{ $t('seizure_status_graph') }}</h3>
            <table>
              <tr>
                <td :style="`padding-right: ${$t('__locale') == 'en' ? '40px' : '20px'}`">{{ $t('display_period') }}</td>
                <td><time v-if="pdf.filterTypeActive !==0">{{ pdf.dateFrom }} ~ </time>{{ pdf.dateEnd }}<span>（{{filterType[pdf.filterTypeActive]}}) | {{ displayType[pdf.displayTypeActive] }}</span></td>
              </tr>
              <tr>
                <td>{{ $t('seizure_type') }}</td>
                <td>{{ seizuresShortcat }}</td>
              </tr>
            </table>
          </div>
          <p>{{ $t('number_of_seizures') }}</p>
          <div class="graph-inner-area" :style="[pdf.displayMethodActive == 1 ? { 'overflow-x': 'auto'} : { 'overflow-x': 'hidden'}]">
            <bar-chart
              :chartData="chartData"
              :options="options"
              :plugins="plugins"
              ref="chart"
              id="chart-js"
              style="position: relative; width: 754px; height: 300px;"
            >
            </bar-chart>
            <div v-show="[0,1,2].includes(pdf.filterTypeActive) || [1,2].includes(pdf.displayTypeActive) || pdf.displayMethodActive === 1">
              <div id="camera" :style="{ width:tableWidth + 'px' }" style="display: flex;">
                <div style="min-width: 80px"></div>
                <table id="show-camera-icon" class="show-table" :style="{ width: (tableWidth - 104)+'px', height: '20px' }">
                </table>
              </div>
              <div id="seizure-medication" :style="{ width: tableWidth + 'px' }" style="display: flex;">
                <div class="fs10" style="min-width: 80px">{{ $t('dosing_during_seizures') }}</div>
                <table id="show-seizure-medication" class="show-table" :style="{ width: (tableWidth - 104)+'px', height: '20px' }">
                </table>
              </div>
            </div>
            <div id="medication-taken-list-0"></div>
          </div>
          <div class="graph-info-area mt10 clearfix" v-if="pdf.pdfList.medicineTaken.length > maxMedicineTaken">
            <div class="inner-graph-info mb10">
              <p class="caution-txt fs10">{{ $t('other_medications_are_available') }}</p>
            </div>
          </div>
          <div id="list-seizure-shortcat-pdf" style="display: grid; margin-top: 10px;">
            <div style="display: inline-flex; margin-right: 20px;" v-for="(type, index) in legends" :key="index">
              <div v-if="type.index === 5" style="margin-right: 5px; height: 15px; width:30px; margin-top: 2px" :style="{backgroundColor: type.pattern}"></div>
              <canvas v-else :id="`canvas${type.index}`" width="30px" height="15px" style="margin-right: 5px; margin-bottom: 5px; margin-top: 2px "></canvas>
              <p class="fs13" style="text-align: center;">
                {{ type.name ? type.index !== null ? shortcatLabel[type.index] + ': ' + type.name : type.name : shortcatLabel[type.index] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // type : [0, 1, 2, 3, 4, 5] => [date, week, month, 3 month, 6 month, year]
  import BarChart from './BarChart.js'
  import Spinner from "@/js/components/Spinner"
  import moment from 'moment'
  import { mapState, mapGetters } from 'vuex'
  import { correctColumnWidthData, makeMedicineBarForMedicineAmountForPDF, getMonthBetweenDate, subLabelYearMonth } from "@/js/commons/commons"
  import { defaultDatasets, otherPattern } from '@/js/commons/chartConfig'

  const maxMedicineTaken = 10
  const PAGE_HEIGHT = 1123
  const PAGE_PADDING = 20
  const SEIZURE_CHART_HEIGHT = 320
  const PAGE_TITLE_HEIGHT = 105

  export default {
    props: ['totalPage'],
    components: {
      BarChart,
      Spinner
    },
    data () {
      return {
        chartData: {
          labels: [],
          datasets: [],
          temp_labels: [],
          scroll: null,
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: {
                color: "rgba(0, 0, 0, 0)"
              }
            }],
            yAxes: [{
              stacked: true,
              afterFit: function(scaleInstance) {
                scaleInstance.width = 80
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
                suggestedMax: 5
              }
            }]
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          layout: {
            padding: {
              bottom: 15,
              right: 25,
            },
          },
        },
        plugins: [subLabelYearMonth],
        displayMethod: [this.$t('summary'), this.$t('scroll')],
        displayType: [this.$t('by_day'), this.$t('by_week'), this.$t('by_month')],
        filterType: [
          this.$t('one_day'), 
          this.$t('one_week'), 
          this.$t('one_month'), 
          this.$t('three_months'), 
          this.$t('six_months'), 
          this.$t('one_year'), 
          this.$t('three_year'),
          this.$t('five_year'),
          this.$t('all_periods')
        ],
        iconSize: '12px',
        tableWidth: null,
        maxMedicineTaken,
        shortcatLabel: ['A', 'B', 'C', 'D', 'E', 'F'],
      }
    },
    computed: {
      ...mapState({
        seizures: state => state.patient.seizures,
        info: state => state.patient.info,
        basic_info: state => state.patient.basic_info,
        doctorInfo: state => state.auth.doctorInfo,
        pdf: state => state.patient.pdf,
        medicineColors: state => state.medicineColor.medicineColors,
      }),
      ...mapGetters({
        shortcats: 'patient/shortcats'
      }),
      gender() {
        return this.info.gender === 0 ? this.$t('male') : this.info.gender === 1 ? this.$t('female') : this.$t('not_identify')
      },
      age() {
        return moment().diff(moment(new Date(this.info.birthday)), "years")
      },
      seizuresShortcat() {
        const shortcat = this.shortcats.map((item) => item.shortcat_name)
        return shortcat.filter(function (item) {
          return item != null;
        }).join(this.$t('comma'))
      },
      legends() {
        const legendArr = []
        this.shortcats.map((shortcat) => {
          const index = defaultDatasets.findIndex((item) => item.index === shortcat.shortcat_index)
          legendArr.push({
            index: defaultDatasets[index].index,
            name: shortcat.shortcat_name,
            pattern: defaultDatasets[index].backgroundColor
          })
        })
        legendArr.push({ index: null, name: this.$t('others'), pattern: otherPattern })
        return legendArr
      }
    },
    async mounted () {
      this.legends.forEach(legend => {
        if (legend.index !== 5) {
          const canvasId = 'canvas' + legend.index
          var c = document.getElementById(canvasId)
          var ctx = c.getContext("2d")
          ctx.rect(0, 0, 30, 15)
          ctx.fillStyle = legend.pattern
          ctx.fill()
        }
      })
      await this.setChartData()
    },
    methods: {
      getMedicineColor(medicineName) {
        const medicineColor = this.pdf.medicineColors.find((item) => item.medicine_name === medicineName)
        if (medicineColor) {
          return medicineColor.dr_site_color_bold
        }
        return '#FF89C0'
      },
      setChartData() {
        const datasets = []
        const shortcats = this.shortcats
        const { videoList, medicineList, medicineTaken, labels, dataSeizure } = this.pdf.pdfList
        defaultDatasets.forEach((item, index) => {
          if (shortcats.map((item) => item.shortcat_index).includes(index)) {
            let dataIndex = _.findIndex(dataSeizure, function(seizure) { return seizure.shortcat_index === index })
            if (dataIndex !== -1) item.data = dataSeizure[dataIndex].data
            else item.data = _.fill(Array(this.chartData.labels.length), 0)
            datasets.push(item)
          }
          const seizureNull = 6
          if (index === seizureNull) {
            let dataOther = _.findIndex(dataSeizure, function(seizure) { return seizure.shortcat_index === null })
            if (dataOther !== -1) item.data = dataSeizure[dataOther].data
            else item.data = _.fill(Array(this.chartData.labels.length), 0)
            datasets.push(item)
          }
        })

        this.tableWidth = parseInt(document.getElementById("bar-chart").style.width, 10)
        // show info
        let iconSize = this.iconSize
        let tableCameraElement = document.getElementById("show-camera-icon")
        tableCameraElement.innerHTML = ''
        // var width = 100/videoList.length

        let widthList = correctColumnWidthData(this.tableWidth - 80, videoList.length);

        var newRow = "<tr>"
        videoList.forEach(function(item, index, arr) {
          if (item) {
            newRow += `<th class="abc def" style="text-align: center; width:${widthList[index]}px"><img style="width:${iconSize}; height:${iconSize}" src="/common/img/icon-video.png" /></th>`
          } else {
            newRow += `<th class="abc" style="width:${widthList[index]}px"></th>`
          }
        })
        newRow += "</tr>"
        tableCameraElement.insertAdjacentHTML('beforeend', newRow)

        //show medicine info
        let tableSeizureMedication = document.getElementById("show-seizure-medication")
        tableSeizureMedication.innerHTML = ''
        // var width = 100/medicineList.length
        var newRow = "<tr>"
        medicineList.forEach(function(item, index, arr) {
          if (item) {
            newRow += `<th style="text-align: center; width:${widthList[index]}px"><span>
              <img width="${iconSize}" height="${iconSize}" src="/images/icon_medication_status.png">
            </span></th>`
          } else {
            newRow += `<th style="width:${widthList[index]}px"></th>`
          }
        })
        newRow += "</tr>"
        tableSeizureMedication.insertAdjacentHTML('beforeend', newRow)
        let maxHeightForMedicineList = PAGE_HEIGHT - (PAGE_PADDING * 2) - PAGE_TITLE_HEIGHT 
          - Math.ceil(document.getElementsByClassName('child-infor')[0].clientHeight)
          - Math.ceil(document.querySelector('.content .mb15').clientHeight)
          - Math.ceil(document.getElementById('camera').clientHeight)
          - Math.ceil(document.getElementById('seizure-medication').clientHeight)
          - SEIZURE_CHART_HEIGHT
        let tableMedicationTaken = document.getElementById('medication-taken-list-0')
        tableMedicationTaken.innerHTML = ''
        let medicineBar = makeMedicineBarForMedicineAmountForPDF(medicineTaken, this.pdf.filterTypeActive, this.tableWidth, this.pdf.medicineColors, maxHeightForMedicineList, 0) 
        let medicinBarShowed = medicineBar.rowShowed
        let addNewpage = medicineBar.stillHaveData
        tableMedicationTaken.insertAdjacentHTML('beforeend', medicineBar.data)
        let numberNewPage = 0
        while (addNewpage) {
          numberNewPage += 1
          maxHeightForMedicineList = PAGE_HEIGHT - (PAGE_PADDING * 2) - PAGE_TITLE_HEIGHT
          let medicineBarSplited = makeMedicineBarForMedicineAmountForPDF(medicineTaken, this.pdf.filterTypeActive, this.tableWidth, this.pdf.medicineColors, maxHeightForMedicineList, medicinBarShowed)
          this.makeNewPage(medicineBarSplited.data, numberNewPage)
          medicinBarShowed = medicineBarSplited.rowShowed
          addNewpage = medicineBarSplited.stillHaveData
        }
        let shortcatElement = document.getElementById('list-seizure-shortcat-pdf')
        let shortcatElementLength = Math.ceil(document.getElementById('list-seizure-shortcat-pdf')?.clientHeight) || 0
        let lastPageContent = [...document.querySelectorAll('.p20')].pop()
        shortcatElement.remove()
        if(PAGE_HEIGHT - Math.ceil(lastPageContent.clientHeight) < shortcatElementLength) {
          this.makeNewPage('', numberNewPage+1)
        }
        [...document.querySelectorAll('.p20')].pop().appendChild(shortcatElement)
        // end medicine taken
        this.chartData.labels = labels
        this.chartData.temp_labels = getMonthBetweenDate(this.pdf.dateFrom, this.pdf.dateEnd)
        this.chartData.datasets = datasets
        let chart = this.$refs.chart.$data._chart
        this.chartData.scroll = this.displayMethodActive
        if (this.pdf.seizureTypeActive === 0 && this.pdf.seizuresTypeActive.length === (this.legends.filter(i => i.name)).length) {
          datasets.forEach(function(e, i) {
            chart.getDatasetMeta(i).hidden = null
          })
        } else {
          // let indexWithoutAll = this.pdf.seizureTypeActive - 1
          // let alreadyHidden = (chart.getDatasetMeta(indexWithoutAll).hidden === null) ? false : chart.getDatasetMeta(indexWithoutAll).hidden
          // datasets.forEach(function(e, idx) {
          //   let meta = chart.getDatasetMeta(idx)
          //   if (idx !== indexWithoutAll) {
          //     if (!alreadyHidden) meta.hidden = meta.hidden === null ? !meta.hidden : null
          //     else if (meta.hidden === null) meta.hidden = true
          //   } else if (idx === indexWithoutAll) meta.hidden = null
          // })

          datasets.forEach((item, index) => {
            let indexWithout = index + 1
            if (this.pdf.seizuresTypeActive.includes(indexWithout)) chart.getDatasetMeta(index).hidden = null
            else chart.getDatasetMeta(index).hidden = true
          })
        }
        chart.update()
      },
      makeNewPage(content, numberNewPage) {
        let newPage = document.createElement('div')
        newPage.classList.add('page')
        newPage.innerHTML = ''
        var newEl = ''
        newEl += 
        `<div class="inner-graph-content fs13">
          <div class="print-info-area mt20 mb20">
            <div class="p20">
              <div class="header heghtHeader" style="margin-bottom: 20px;">
                <div class="styleHeader">
                  <div class="fLeft">${this.$t('doctor_in_charge_colon')} ${this.$t('doctor_doctor', {doctor: this.doctorInfo.name})}</div>
                  <div class="fRight">${this.$t('output_date_and_time')} ${ this.pdf.currentDateTime } &emsp; xx/XX</div>
                </div>
                <div class="titleHeder">
                  <h1>${this.$t('patient_information_and_seizure_status_graph')}</h1>
                </div>
              </div>
              <div class="content">
                <div class="graph-inner-area" style="overflow-x: hidden;">
                  <div id="medication-taken-list-${numberNewPage}">
                    ${content}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`
        newPage.insertAdjacentHTML('beforeend', newEl)
        document.querySelector('#main-pdf div').appendChild(newPage)
      }
    }
  }
</script>

<style lang="css">
  .circleWithScoll {
    height: 10px;
    width: 10px;
    background-color: rgb(255,142,161);
    border-radius: 50%;
    display: inline-block;
    color: white;
  }

  .icon_suppository_PDF {
    background:url(../../../common/img/icon_medication_status.png) no-repeat;
    background-size: 12px 15px;
    padding: 2px 0px 2px 20px;
  }

  .chart-legend li span{
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 5px;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(208, 201, 201);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgb(208, 201, 201);
  }
  .fs13 {
    font-size: 13px;
  }
  .fs10 {
    font-size: 10px;
  }
  .fs18 {
    font-size: 18px;
  }
  .print-info-area {
    background-color: white;
    height: 1123px;
  }
  .styleHeader {
    overflow: hidden;
  }
  .titleHeading {
    font-size: 18px;
    border-bottom: 1px solid #f98ea1;
    margin-bottom: 10px;
  }
  .hr {
    height: 4px;
    border-width: 0;
    background-color: #f98ea1;
  }
  .p-info-txt {
    padding-left: 15px;
    padding-right: 20px;
  }
  .hrSmall {
    height: 0.5px;
    border-width: 0;
    background-color: #f98ea1;
  }
  .heghtHeader {
    height: 80px;
  }
  .title {
    text-align: center;
    font-size: 25px;
    font-weight: 600;
    margin: 10px;
  }
  .p20 {
    padding: 20px;
  }
  .m25 {
    margin: 25px 0 2px;
  }
  .mb10 {
    margin-bottom: 10px;
  }
  .mb15 {
    margin-bottom: 15px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .fLeft {
    float: left;
  }
  .fRight {
    float: right;
  }
  .mb40 {
    margin-bottom: 40px;
  }
  .graph-info-area {
    width: 100%;
  }
  .graph-info-area .inner-graph-info {
      font-size: 0.8rem;
  }
  .graph-info-area .inner-graph-info .caution-txt {
      text-align: right;
  }
  .titleHeder h1 {
      font-size: 23px;
      font-weight: 300;
      text-align: center;
      border-bottom: 4px solid #f98ea1;
      padding-bottom: 18px;
  }
  .has-tooltip {
    font-size: 0.8rem;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>